import { NgModule } from "@angular/core";
import {
    Routes,
    RouterModule,
    PreloadingStrategy,
    PreloadAllModules,
} from "@angular/router";
import { ROUTES } from "../app/shared/utils/routes";
import { CMS_PAGE_ID } from "./shared/enum/cms-page-id.enum";
import { StepPageResolver } from "./shared/resolvers/step-page.resolver";
import { environment } from "../environments/environment";

const BiometryChoice = {
    linkMfe: () =>
                import("./fraude-face/components/biometry/biometry.module").then(
                    (m) => m.BiometryModule
                ),
       
    mobMfe: () =>
                import("./mfe-biometry/mfe-biometry.module").then(
                    (m) => m.MfeBiometryModule
                ),
}
const switchMfeBio = environment.biometry.useMfeBiometry === 'true'? BiometryChoice.mobMfe : BiometryChoice.linkMfe; 



const routes: Routes = [
    {
        path: ROUTES.identification.url,
        loadChildren: () =>
            import("./identification/identification.module").then(
                (m) => m.IdentificationModule
            ),
    },
    // {
    //     path: ROUTES.error.url,
    //     loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
    // },
    {
        path: ROUTES.token_validation.url,
        loadChildren: () =>
            import("./token/token.module").then((m) => m.TokenModule),
    },
    {
        path: ROUTES.identity_recovery.url,
        loadChildren: () =>
            import("./identity-recovery/identity-recovery.module").then(
                (m) => m.IdentityRecoveryModule
            ),
    },
    {
        path: ROUTES.client_name_view.url,
        loadChildren: () =>
            import("./client-name/client-name.module").then(
                (m) => m.ClientNameModule
            ),
    },
    {
        path: ROUTES.client_name_edit.url,
        loadChildren: () =>
            import("./client-name-edit/client-name-edit.module").then(
                (m) => m.ClientNameEditModule
            ),
    },
    {
        path: ROUTES.identity_recovery.url,
        loadChildren: () =>
            import("./identity-recovery/identity-recovery.module").then(
                (m) => m.IdentityRecoveryModule
            ),
    },
    {
        path: ROUTES.client_data_link.url,
        loadChildren: () =>
            import("./client-data-link/client-data.module").then(
                (m) => m.ClientDataModule
            ),
    },
    {
        path: ROUTES.client_data.url,
        loadChildren: () =>
            import("./client-data/client-data.module").then(
                (m) => m.ClientDataModule
            ),
    },

    {
        path: ROUTES.step_confirmation.url,
        loadChildren: () =>
            import("./confirmation/confirmation.module").then(
                (m) => m.ConfirmationModule
            ),
    },

    {
        path: ROUTES.client_address.url,
        loadChildren: () =>
            import("./client-address/client-address.module").then(
                (m) => m.ClientAddressModule
            ),
    },
    {
        path: ROUTES.fraude_face_biometry.url,
        loadChildren: switchMfeBio
    },
    {
        path: ROUTES.fraude_face_selfie.url,
        loadChildren: () =>
            import("./fraude-face/components/selfie/selfie.module").then(
                (m) => m.SelfieModule
            ),
    },
    {
        path: ROUTES.step_finish.url,
        loadChildren: () =>
            import("./finish/finish.module").then((m) => m.FinishModule),
    },
    {
        path: ROUTES.fraude_face_selfie_capture.url,
        loadChildren: () =>
            import("./fraude-face/components/selfie/selfie.module").then(
                (m) => m.SelfieModule
            ),
    },
    {
        path: ROUTES.fraude_doc_documents.url,
        data: {
            route: ROUTES.fraude_doc_documents,
        },
        loadChildren: () =>
            import("./fraud-doc/documents.module").then(
                (m) => m.DocumentsModule
            ),
    },
    {
        path: ROUTES.fraude_doc_documents_capture.url,
        data: {
            route: ROUTES.fraude_doc_documents_capture,
        },
        loadChildren: () =>
            import("./fraud-doc/documents.module").then(
                (m) => m.DocumentsModule
            ),
    },
    {
        path: ROUTES.offer_package.url,
        loadChildren: () =>
            import("./offer-package/offer-package.module").then(
                (m) => m.OfferPackageModule
            ),
    },
    {
        path: ROUTES.offer_package_link.url,
        loadChildren: () =>
            import("./offer-package/offer-package.module").then(
                (m) => m.OfferPackageModule
            ),
    },
    {
        path:ROUTES.offer_card_link.url,
        loadChildren: () =>
            import('./offer-card-unified/offer-card-unified.module').then(
                m => m.OfferCardUnifiedModule)
    },
    {
        path:ROUTES.offer_card.url,
        loadChildren: () =>
            import('./offer-card/offer-card.module').then(
                m => m.OfferCardModule)
    },
    {
        path: ROUTES.offer_card_unified.url,
        loadChildren: () =>
            import("./offer-card-unified/offer-card-unified.module").then(
                (m) => m.OfferCardUnifiedModule
            ),
    },
    {
        path: ROUTES.offer_express_card.url,
        loadChildren: () =>
            import("./offer-express-card/offer-express-card.module").then(
                (m) => m.OfferExpressCardModule
            ),
    },
    {
        path: ROUTES.offer_card_flow.url,
        loadChildren: () =>
            import("./offer-card-package/offer-card-flow.module").then(
                (m) => m.OfferCardFlowModule
            ),
    },
    {
        path: ROUTES.holderAdvice.url,
        loadChildren: () =>
            import("./holder-advice/holder-advice.module").then(
                (m) => m.HolderAdviceModule
            ),
    },
    {
        path: ROUTES.offer_scp.url,
        loadChildren: () =>
            import("./offer-scp/offer-scp.module").then(
                (m) => m.OfferSCPModule
            ),
    },
    {
        path: ROUTES.offer_overdraft.url,
        loadChildren: () =>
            import("./offer-overdraft/offer-overdraft.module").then(
                (m) => m.OfferOverdraftModule
            ),
    },
    {
        path: ROUTES.step_secret_access.url,
        loadChildren: () =>
            import("./secret-access/secret-access.module").then(
                (m) => m.SecretAccessModule
            ),
    },
    {
        path: ROUTES.offer_salary_account.url,
        loadChildren: () =>
            import("./offer-salary-account/offer-salary-account.module").then(
                (m) => m.OfferSalaryAccountModule
            ),
    },
    {
        path: ROUTES.recap.url,
        loadChildren: () => import('./recap/recap.module').then(m => m.RecapModule)
    },
    {
        path: ROUTES.accountOpen.url,
        data: {
            cmsId: CMS_PAGE_ID.pageError,
            icon: "checkmark-in-a-circle",
            error: "accountHolder",
            buttonText_1: "Acesse o app Santander",
            title: "Você já é cliente Santander!",
            subtitle:
                "Deu tudo certo com seus documentos e sua conta está pronta para ser acessada",
            redirectUrl: "",
            showDownloadButton: true,
            route: {
                path: "proposta-aprovada",
            },
        },
        loadChildren: () =>
            import("./error/error.module").then((m) => m.ErrorModule),
    },
    {
        path: ROUTES.errorAccountRejected.url,
        data: {
            route: {
                path: "conta-indisponivel",
            },
            cmsId: CMS_PAGE_ID.pageError,
            icon: "error",
            error: "accountUnavailable",
            redirectUrl: "https://www.santander.com.br/agencias",
            buttonText_1: "Ok, entendi",
            title: "Conta não aprovada.",
            subtitle: "Desculpe, não foi possível abrir a sua conta pelos canais digitais.",
        },
        resolve: {
            cmsPage: StepPageResolver,
        },
        loadChildren: () =>
            import("./error/error.module").then((m) => m.ErrorModule),
    },
    {
        path: ROUTES.errorOffline.url,
        data: {
            route: {
                path: "erro-sem-conexao",
            },
            cmsId: CMS_PAGE_ID.pageError,
            icon: "error",
            error: "errorOffline",
            buttonText_1: "Tentar novamente",
            title: "Ops, você está off-line",
            subtitle: "Por favor, verifique sua conexão e tente novamente",
            redirectUrl: "{{landing}}",
        },
        loadChildren: () =>
            import("./error/error.module").then((m) => m.ErrorModule),
    },
    {
        path: ROUTES.errorGeneric.url,
        data: {
            route: {
                path: "erro-de-servico",
            },
            cmsId: CMS_PAGE_ID.pageError,
            icon: "alert",
            error: "serviceError",
            buttonText_1: "Voltar para o inicio",
            title: "Atenção!",
            subtitle: "Não foi possível completar a operação",
            redirectUrl: "{{landing}}",
        },
        loadChildren: () =>
            import("./error/error.module").then((m) => m.ErrorModule),
    },
    {
        path: "pagina-nao-encontrada",
        data: {
            route: {
                path: "pagina-nao-encontrada",
            },
            icon: "error",
            error: "notFound",
            buttonText_1: "Voltar para o inicio",
            title: "Ops, essa página não existe :/",
            subtitle: "Volte à página inicial e abra sua conta agora!",
            redirectUrl: "{{landing}}",
        },
        loadChildren: () =>
            import("./error/error.module").then((m) => m.ErrorModule),
    },
    {
        path:ROUTES.errorAccountWarning.url,
        data:{
            route: {
                path: 'aviso'
            },
            icon:'alert',
            error: 'accountWarning',
            buttonText_1:'Voltar para o inicio',
            title: 'Não podemos seguir com a operação',
            subtitle:'Tente novamente em alguns minutos.',
            redirectUrl:'{{landing}}',
            cmsId: CMS_PAGE_ID.pageError
        },
        loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
    },
    {
        path: "**",
        redirectTo: "pagina-nao-encontrada",
        pathMatch: "full",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
